// extracted by css-extract-rspack-plugin
export default {"cls1":"Timer-cls1_Hd4","cls2":"Timer-cls2_oAp Timer-cls1_Hd4","mini":"Timer-mini_uQf","dark":"Timer-dark_4ir"};